<template>
  <div class="col-12 mb-1 m-0 p-0">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group class="required-control">
          <label class="font-weight-bold">Cửa hàng:</label>
          <Autosuggest
            class="border-radius-none mt-2"
            :model="stockSlip.sourceWarehouseName"
            :suggestions="stores"
            placeholder="Cửa hàng"
            :limit="200"
            @select="onSelectedSourceWarehouse"
            @change="onInputChangeSourceWarehouse"
            suggestionName="name"
            :disabled="!editable"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group class="required-control">
          <label class="font-weight-bold">Lý do:</label>
          <Autosuggest
            class="border-radius-none mt-2"
            :model="stockSlip.reasonName"
            :suggestions="reasons"
            placeholder="Lý do"
            :limit="200"
            @select="onSelectedReason"
            @change="onInputChangeReason"
            suggestionName="name"
            :disabled="!editable"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12">
        <b-form-group>
          <label>Ghi chú:</label>
          <b-form-textarea
            size="sm"
            v-model="stockSlip.notes"
            :placeholder="'Thêm nội dung ghi chú...'"
            :rows="6"
            :max-rows="6"
            :disabled="!editable"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  props: ['stockSlip', 'stores', 'editable', 'reasons'],
  created() {},
  data() {
    return {};
  },
  components: { Autosuggest },
  methods: {
    onSelectedSourceWarehouse(data) {
      this.$emit('onSelectedSourceWarehouse', data);
    },
    onInputChangeSourceWarehouse(data) {
      this.$emit('onInputChangeSourceWarehouse', data);
    },
    onSelectedReason(data) {
      this.$emit('onSelectedReason', data);
    },
    onInputChangeReason(data) {
      this.$emit('onInputChangeReason', data);
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="css" scoped>
.center-label label {
  margin-bottom: 0px;
}

.form-group label {
  font-weight: 500;
}
</style>
